module.exports = __webpack_public_path__ + "img/tank-4.57774894.png";